export function LoadingScreen() {
  return (
    <main className="loading-screen" aria-label="Laddar">
      <img src="/images/kilsok_logo_new.png" alt="Kils OK" />
      <span className="spinner" aria-hidden="true" />
    </main>
  );
}
